var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"text-right pa-6",staticStyle:{"background-color":"#FFFFFF"}},[_c('v-btn',{attrs:{"rounded":"","color":'#039be5',"disabled":this.processBtn},on:{"click":_vm.triggerProcess}},[_vm._v(_vm._s(_vm.$t("downloadView.processNewDownload")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }